/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const Mouth2 = ({ className }) => {
  return (
    <svg
      className={`mouth-2 ${className}`}
      fill="none"
      height="13"
      viewBox="0 0 32 13"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="rect"
        fill="#EDB98A"
        height="12.1"
        transform="translate(0.355469 0.390625)"
        width="31.5"
      />

      <path
        className="path"
        clipRule="evenodd"
        d="M10.598 4.55104C10.9065 7.16127 13.2545 9.19082 16.1053 9.19082C18.9648 9.19082 21.3185 7.14871 21.6154 4.52684C21.6392 4.31583 21.3893 3.96582 21.0761 3.96582C16.732 3.96582 13.4038 3.96582 11.1722 3.96582C10.8572 3.96582 10.5671 4.28989 10.598 4.55104Z"
        fill="black"
        fillOpacity="0.7"
        fillRule="evenodd"
      />

      <mask
        className="mask"
        height="7"
        id="mask0_2633_240"
        maskUnits="userSpaceOnUse"
        width="12"
        x="10"
        y="3"
      >
        <path
          className="path"
          clipRule="evenodd"
          d="M10.598 4.55104C10.9065 7.16127 13.2545 9.19082 16.1053 9.19082C18.9648 9.19082 21.3185 7.14871 21.6154 4.52684C21.6392 4.31583 21.3893 3.96582 21.0761 3.96582C16.732 3.96582 13.4038 3.96582 11.1722 3.96582C10.8572 3.96582 10.5671 4.28989 10.598 4.55104Z"
          fill="white"
          fillRule="evenodd"
        />
      </mask>

      <g className="g" mask="url(#mask0_2633_240)">
        <path
          className="path"
          clipRule="evenodd"
          d="M11.7305 3.14043C11.7305 1.9254 12.7154 0.94043 13.9305 0.94043H18.5721C19.7872 0.94043 20.7721 1.9254 20.7721 3.14043C20.7721 4.35546 19.7872 5.34043 18.5721 5.34043H13.9305C12.7154 5.34043 11.7305 4.35546 11.7305 3.14043Z"
          fill="white"
          fillRule="evenodd"
        />

        <ellipse
          className="ellipse-33"
          cx="14.6468"
          cy="10.0152"
          fill="#FF4F6D"
          rx="3.20833"
          ry="3.025"
        />

        <ellipse
          className="ellipse-33"
          cx="17.5638"
          cy="10.0152"
          fill="#FF4F6D"
          rx="3.20833"
          ry="3.025"
        />
      </g>
    </svg>
  );
};
